export default "__VITE_ASSET__C4mAl9ge__"